<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    colSpan?: number;
    rowSpan?: number;
    noBorderBottom?: boolean;
    noBorderRight?: boolean;
    borderColor?: string;
  }>(),
  {
    colSpan: 1,
    rowSpan: 1,
    borderColor: '',
  },
);
</script>

<template>
  <div
    :class="[
      $style.item,
      { [$style.item_noBorderRight!]: noBorderRight },
      { [$style.item_noBorderBottom!]: noBorderBottom },
      { [$style.item_col3!]: props.colSpan === 3 },
      { [$style.item_col2!]: props.colSpan === 2 },
      { [$style.item_col1!]: props.colSpan === 1 },
    ]"
    :style="{
      gridRow: `span ${rowSpan || 1}`,
      borderColor: borderColor || undefined,
    }"
  >
    <slot />
  </div>
</template>

<style module lang="scss">
.item {
  border-bottom: 1px solid var(--color-gray-line);
  border-right: 1px solid var(--color-gray-line);
  overflow: hidden;

  &_noBorderRight {
    border-right: none;
  }
  &_noBorderBottom {
    border-bottom: none;
  }

  &_col1 {
    grid-column: span 1;
  }
  &_col2 {
    grid-column: span 2;
  }
  &_col3 {
    grid-column: span 3;
  }
}

@media (min-width: 768px) and (max-width: 1389px) {
  .item {
    &_col1 {
      grid-column: span 1;
    }
    &_col3 {
      grid-column: span 2;
    }
  }
}
// 2 колонки максимум
@media (min-width: 480px) and (max-width: 767px) {
  .item {
    &_col3 {
      grid-column: span 2;
    }
  }
}

// 1 колонка максимум
@media (max-width: 479px) {
  .item {
    &_col2 {
      grid-column: span 1;
    }
    &_col3 {
      grid-column: span 1;
    }
  }
}
</style>
